function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
import PropTypes from '../../_snowpack/pkg/prop-types.js';

function SvgComponent({
  color = '#DAF0ED',
  strokeColor = '#828A90',
  height,
  size,
  width,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: width || size,
    height: height || size
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M9.78 6.9v.34H15.2a1.49 1.49 0 010 2.98H9.78V15.17a1.49 1.49 0 01-2.97 0V10.3H1.9a1.54 1.54 0 110-3.07H6.81V1.84a1.49 1.49 0 112.97 0v5.05z",
    fill: color,
    stroke: strokeColor,
    strokeWidth: "0.7"
  }));
}

SvgComponent.defaultProps = {
  size: 15
};
SvgComponent.propTypes = {
  color: PropTypes.string,
  strokeColor: PropTypes.string,
  height: PropTypes.number,
  size: PropTypes.number,
  width: PropTypes.number
};
export default SvgComponent;